import request from "../fieldsDrupal/loadField";
export default {
  preEditorConfig() {
    return {
      codeSnippet_theme: "monokai_sublime",
      stylesSet: [],
      // toolbars configs => https://ckeditor.com/latest/samples/toolbarconfigurator/#advanced
      toolbar: [
        {
          name: "document",
          items: [
            "Source",
            "-",
            "Save",
            "NewPage",
            "Preview",
            "Print",
            "-",
            "Templates",
          ],
        },
        {
          name: "clipboard",
          items: [
            "Cut",
            "Copy",
            "Paste",
            "PasteText",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
          ],
        },
        // {
        //   name: "editing",
        //   items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"],
        // },
        // {
        //   name: "forms",
        //   items: [
        //     "Form",
        //     "Checkbox",
        //     "Radio",
        //     "TextField",
        //     "Textarea",
        //     "Select",
        //     "Button",
        //     "ImageButton",
        //     "HiddenField",
        //   ],
        // },
        //"/",
        {
          name: "basicstyles",
          items: [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
            "CopyFormatting",
            "RemoveFormat",
          ],
        },
        {
          name: "paragraph",
          items: [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language",
          ],
        },
        { name: "links", items: ["Link", "Unlink", "Anchor"] },
        {
          name: "insert",
          items: [
            "Image",
            "Flash",
            "Table",
            "HorizontalRule",
            "Smiley",
            "SpecialChar",
            "PageBreak",
            "Iframe",
          ],
        },
        "/",
        { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
        { name: "colors", items: ["TextColor", "BGColor"] },
        { name: "tools", items: ["Maximize", "ShowBlocks"] },
        { name: "about", items: ["About"] },
      ],
      contentsCss: this.getImportCss(),
      on: {
        instanceReady: function (ev) {
          ev.sender.dataProcessor.writer.setRules("p", {
            indent: true,
            breakBeforeOpen: true,
            breakAfterOpen: false,
            breakBeforeClose: true,
            breakAfterClose: true,
          });
          ev.sender.dataProcessor.writer.setRules("img", {
            indent: true,
            breakBeforeOpen: true,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
          ev.sender.dataProcessor.writer.setRules("h1", {
            indent: true,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });

          ev.sender.dataProcessor.writer.setRules("h2", {
            indent: true,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
          ev.sender.dataProcessor.writer.setRules("h3", {
            indent: true,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
          ev.sender.dataProcessor.writer.setRules("h4", {
            indent: true,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
          ev.sender.dataProcessor.writer.setRules("h5", {
            indent: true,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
          ev.sender.dataProcessor.writer.setRules("h6", {
            indent: true,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
          ev.sender.dataProcessor.writer.setRules("div", {
            indent: true,
            breakBeforeOpen: true,
            breakAfterOpen: true,
            breakBeforeClose: true,
            breakAfterClose: false,
          });
        },
      },
    };
  },
  onNamespaceLoaded(CKEDITOR) {
    CKEDITOR.config.allowedContent = true;
    // CKEDITOR.config.contentsCss =
    // "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";
    CKEDITOR.config.htmlEncodeOutput = false;
    CKEDITOR.config.entities = false;
    // CKEDITOR.config.entities_processNumerical = 'force';
    CKEDITOR.dtd.$removeEmpty.span = 0;
    CKEDITOR.dtd.$removeEmpty.i = 0;
    CKEDITOR.dtd.$removeEmpty.label = 0;
  },
  // Le parent surchargera cette partie enfin de fournir ces styles.
  /**
   * example in parent : 
   * ckeditorConfig.getImportCss = function () {
        return (
          "@import '" +
          request.getBaseUrl() +
          "/themes/contrib/wb_universe/node_modules/%40fortawesome/fontawesome-free/css/all.min.css'; @import 'https://wb-horizon.com/themes/custom/wb_horizon_com/css/vendor-style.css'; "
        );
      };
   * @returns 
   */
  getImportCss() {
    return "";
  },
};
